/**
 * AuthContext — shared interface consumed by all components.
 * The actual provider (DualAuthProvider) implements this interface.
 */

import { createContext, useContext } from "react";
import type { UserRole, UserData } from "../models/types";

export interface AuthContextType {
  isAuthenticated: boolean;
  isAuthenticating: boolean;
  user: UserData | null;
  userRole: UserRole | null;
  businessUnitId: string | null;
  isAdmin: boolean;
  isSuperAdmin: boolean;
  activeAuth: "okta" | "cognito" | null;
  login: (email: string, password: string) => Promise<void>;
  loginWithOkta: () => void;
  logout: () => Promise<void>;
  refreshUserData: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function useAuth(): AuthContextType {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
